import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Warning, ArrowRight, SignOut } from '@phosphor-icons/react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SubscriptionBlocked = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, { withCredentials: true });
    } catch (error) {
      // Ignore logout errors
    }
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-background to-muted">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="w-20 h-20 rounded-full bg-yellow-100 flex items-center justify-center mx-auto mb-4">
            <Warning size={40} className="text-yellow-600" weight="bold" />
          </div>
          <CardTitle className="text-2xl">Acesso Bloqueado</CardTitle>
          <CardDescription>
            Sua assinatura expirou ou está pendente de pagamento
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="p-4 bg-yellow-50 rounded-lg border border-yellow-200">
            <p className="text-sm text-yellow-800">
              Para continuar utilizando o Aretê, regularize sua assinatura. 
              Após o pagamento, seu acesso será liberado automaticamente.
            </p>
          </div>

          <div className="space-y-3">
            <Button 
              className="w-full" 
              size="lg"
              onClick={() => window.open('https://kiwify.com.br', '_blank')}
            >
              Regularizar Assinatura
              <ArrowRight size={18} className="ml-2" />
            </Button>
            
            <Button 
              variant="outline" 
              className="w-full"
              onClick={handleLogout}
            >
              <SignOut size={18} className="mr-2" />
              Voltar ao Login
            </Button>
          </div>

          <div className="text-center">
            <p className="text-xs text-muted-foreground">
              Precisa de ajuda? Entre em contato com nosso suporte.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionBlocked;
